import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'

const baseURL = process.env.VUE_APP_BASE_URL
// baseURL = window.location.origin + '/api/v1/shop/' // 线上

// 创建axios实例
const service = axios.create({
  baseURL: baseURL,
  timeout: 180000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['Authorization'] = 'Bearer' + ' ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  response => {
    const data = response.data
    const status = response.status
    if (status === 200 || status === 201) {
      // 正常请求返回。登录返回的有access_token， 普通情况返回有status
      if (data.status !== 0 || data.access_token !== null) {
        return response.data
      } else if (data.status === 0) {
        console.log(data)
        return data
      } else {
        Message({
          message: data.error,
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject('error')
      }
    } else {
      Message({
        message: response.message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject('error')
    }
  },
  error => {
    console.log('err ' + error.response) // for debug
    if (error.response.status === 401) {
      Message({
        message: '账号密码输入错误',
        type: 'error',
        duration: 5 * 1000
      })
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service
